import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { I18nProvider } from "./i18n/index.js";
import { AuthProvider } from "./auth/AuthContext.js";
import { App } from "./App.js";
import "./styles/global.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root no encontrado");

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <I18nProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </I18nProvider>
    </BrowserRouter>
  </StrictMode>,
);
